import { TerminationDisallowedReason } from '../../../../../../common/types'
import { Contract } from '../../../../../../common/validations'

export const isTerminationDisallowedBecauseOfPending = (contract: Contract) => {
  if (
    contract.terminationDisallowedReason ===
    TerminationDisallowedReason.PENDING_TERMINATION_REVIEW
  ) {
    return true
  }

  if (
    contract.terminationDisallowedReason ===
    TerminationDisallowedReason.PENDING_TERMINATION_TENANT_APPROVALS
  ) {
    return true
  }

  if (
    contract.terminationDisallowedReason ===
    TerminationDisallowedReason.PENDING_MODIFICATION_REQUEST
  ) {
    return true
  }

  if (
    contract.terminationDisallowedReason ===
    TerminationDisallowedReason.OPEN_CONTINUATION_OFFER
  ) {
    return true
  }

  return false
}
